module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), (_vm.userID > 0) ? _c('b-button', {
    staticClass: "mb-1 mt-1",
    staticStyle: {
      "font-size": "0.575rem"
    },
    attrs: {
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.showUserModal(_vm.userID)
      }
    }
  }, [_vm._v("User Summary")]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "User-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.Page_title
    }
  }, [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "input": _vm.getAssignmentPendencyList
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientIdFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    on: {
      "input": _vm.getAssignmentPendencyList
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Sline")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "id": "shippingFilter",
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": _vm.getAssignmentPendencyList
    },
    model: {
      value: (_vm.shippingFilter),
      callback: function($$v) {
        _vm.shippingFilter = $$v
      },
      expression: "shippingFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "mt-2 ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName4 != 'Export Assignments' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getSalesAss('All_Sales_Excel', 'Export Assignments')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.ExcelBtnName4) + "\n          "), (_vm.ExcelBtnName4 != 'Export Assignments') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('b', [_vm._v("Transport Prefrence: " + _vm._s(_vm.PMC_TransportTypePre))])]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('b', [_vm._v("Branch/CLient Prefrence : " + _vm._s(_vm.PMC_BranchClientPre == '1' ? 'Branch' : 'Client'))])]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('b', [_vm._v("Branch Details")])]), _vm._v(" "), _vm._l((_vm.BranchList), function(item, index1) {
    return _c('b-col', {
      key: index1,
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "md": "4"
      }
    }, [_vm._v("\n        " + _vm._s(parseInt(index1 + 1) + ". " + item.mainLocation) + "\n      ")])
  }), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('b', [_vm._v("Client Details")])]), _vm._v(" "), _vm._l((_vm.ClientList), function(item, index) {
    return _c('b-col', {
      key: index,
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "md": "4"
      }
    }, [_vm._v("\n        " + _vm._s(parseInt(index + 1) + ". " + item.clientName) + "\n      ")])
  }), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "outline-danger",
      "size": "xs"
    },
    on: {
      "click": _vm.hideUserModal
    }
  }, [_vm._v("Close")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26b78389","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/userBasedClient.vue
// module id = 2470
// module chunks = 0